module.exports = __webpack_public_path__ + "static/pic6-c26dca2c62e150c38453461220d482bb.png";